/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import {
  Row,
  Col,
  Popover,
} from 'antd';
import PropTypes from 'prop-types';

import WarningHeader from '../../common/text/WarningHeader';
import { storageUpgradeWarning } from '../../files/fileHelpers';
import OnTraccrCheckbox from '../../common/inputs/OnTraccrCheckbox';

function ExternalFormCheckbox({
  isDisplay,
  onCheckChange: onPropCheckChange,
  value,
  isExternalFormEnabled,
}) {
  const onCheckChange = useCallback((checked) => {
    if (!isExternalFormEnabled) return;
    onPropCheckChange(checked);
  }, [isExternalFormEnabled]);

  const CheckboxWithWarning = useCallback((props) => {
    const warningOpts = {
      title: 'You need to upgrade your account to access this feature',
      action: 'create an external form',
      bodyText: 'Contact your account manager to add this functionality to your account.',
    };

    return isExternalFormEnabled
      ? <OnTraccrCheckbox {...props} />
      : (
        <Popover
          placement="leftBottom"
          trigger="click"
          title={<WarningHeader />}
          content={storageUpgradeWarning(warningOpts)}
        >
          <OnTraccrCheckbox {...props} />
        </Popover>
      );
  }, [isExternalFormEnabled]);

  if (isDisplay && !value) return null;

  return (
    <Row className="form-default-data-row" justify="space-between">
      <Col>
        <Row gutter={10}>
          {!isDisplay && (
            <Col>
              <CheckboxWithWarning
                onChange={onCheckChange}
                // eslint-disable-next-line react/no-unknown-property
                value={value}
                label="External Form"
                hoverNode={!isDisplay && (
                  <div style={{ maxWidth: 400 }}>
                    Check this box to allow users outside of your company to submit
                    this form from the below URL.
                    <br />
                    <br />
                    When a form is submitted, the workflow will be started and the
                    form will be sent to the first step in the workflow.
                    <br />
                    <br />
                    Please note that certain fields are not supported in external forms
                    and will automatically be removed. These fields include:
                    <br />
                    <br />
                    <ul>
                      <li>Tables (except Custom)</li>
                      <li>Choose One or More (except Custom)</li>
                      <li>Signature</li>
                    </ul>
                    <br />
                    Field triggers are also not supported in external forms.
                  </div>
                )}
              />
            </Col>
          )}
          { !!isDisplay && (
            <Col>
              External Form
            </Col>
          )}
        </Row>
      </Col>
    </Row>
  );
}

ExternalFormCheckbox.propTypes = {
  isDisplay: PropTypes.bool,
  onCheckChange: PropTypes.func,
  value: PropTypes.bool,
  isExternalFormEnabled: PropTypes.bool,
};

ExternalFormCheckbox.defaultProps = {
  isDisplay: false,
  onCheckChange: () => {},
  value: false,
  isExternalFormEnabled: false,
};

export default ExternalFormCheckbox;
